// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kogPs","main":"styles_main__sUGem"};